import axios from 'axios';
import fileUriConstants from '../common/uri/file-uri.constants';
import reportUriConstants from '../common/uri/report-uri.constants';
import videoUri from '../common/uri/video-uri.constants';
export interface IUploadService {
    upload(file, config, id?);
    delete(file: string);
    setType(type: string);
    setTab(tab: number);
    cancelRequest(index?: any);
}

/**
 * file upload service
 */
export class FileUploadServices implements IUploadService {
    protected url: string;
    private type: string;
    private tab: number;
    CancelToken = axios.CancelToken;
    cancels: any = [];
    constructor(serviceUrl: string) {
        this.url = serviceUrl;
        this.type = "";
    }

    setType(type: string)
    {
        this.type = type;
    }

    setTab(tab: number) {
        this.tab = tab
    }

    /**
     * upload file 
     * @param file 
     */
    upload(formData, config, id = null) {
        if (typeof this.url !== 'string') {
            throw new TypeError(`Expected a string, got ${typeof this.url}`);
        }

        let reqUrl = this.url;

        if(this.type)
        {
            reqUrl += "?type="+this.type;
        }

        if (this.tab) {
            reqUrl += "&tab=" + this.tab;
        }
        return axios.post(reqUrl, formData, {
            ...config, cancelToken: new this.CancelToken((c) => {
                // An executor function receives a cancel function as a parameter
                this.cancels.push({cancel: c, id});
            }) })
            .then((response: any) => {
                const index = this.cancels.findIndex(x => x.id === id);
                this.cancels.splice(index, 1);
                if (response.data.isSuccess) {
                    return Promise.resolve(response.data.data);
                }
                    
                return Promise.reject(response);   
            })
            .catch(ex => {
                const index = this.cancels.findIndex(x => x.id === id);
                this.cancels.splice(index, 1);
                if (axios.isCancel(ex)) {
                    console.log('Request canceled', ex.message);
                } else {
                    // handle error
                    console.log(ex)
                    return Promise.reject(ex)
                }
            });
    }

    /**
     * delete file 
     * @param filepath 
     */
    delete(filepath: string) {
        if (typeof this.url !== 'string') {
            throw new TypeError(`Expected a string, got ${typeof this.url}`);
        }
        return axios.delete(this.url, { params: { filePath: filepath } });
    }

    cancelRequest(id = null) {
        if (!id) {
            this.cancels.forEach(cancel => {
                cancel.cancel('Operation canceled by the user.');
            });
        } else {
            const index = this.cancels.findIndex(x => x.id === id);
            if (index > -1)this.cancels[index].cancel('Operation canceled by the user.');
            
        }
    }
}

export class PictureUploadServices extends FileUploadServices {
    constructor() {
        super(fileUriConstants.uploadPicture)
    }
}

export class PictureUploadExtractPdfToPictureServices extends FileUploadServices {
    constructor() {
        super(fileUriConstants.updatePdfExtractToPicture)
    }
}

export class DocumentUploadServices extends FileUploadServices {
    constructor() {
        super(fileUriConstants.uploadDocument)
    }
}

export class HistoryUploadService extends FileUploadServices{
    constructor() {
        super(fileUriConstants.uploadHistory);
    }
}

export class DocumentUploadTempService extends FileUploadServices {
    constructor() {
        super(fileUriConstants.uploadTempDocument)
    }
}

export class DocumentUploadAttachService extends FileUploadServices {
    constructor() {
        super(fileUriConstants.uploadAttachDocument)
    }
}

export class UploadMailingPictureService extends FileUploadServices {
    constructor() {
        super(reportUriConstants.UploadPictureMailing)
    }
}

export class VideoUploadService extends FileUploadServices {
    constructor() {
        super(videoUri.upload);
    }

    upload(formData, config, id = null) {
        if (typeof this.url !== 'string') {
            throw new TypeError(`Expected a string, got ${typeof this.url}`);
        }

        return axios.post(this.url, formData, {
            ...config,
            cancelToken: new this.CancelToken((c) => {
                this.cancels.push({ cancel: c, id });
            })
        })
        .then(response => {
            this.removeCancelToken(id);
            const payload = response?.data || {};
            if (payload?.isSuccess === false) {
                return Promise.reject(payload);
            }
            if (payload?.isSuccess === true && payload?.data) {
                return Promise.resolve(payload);
            }
            return Promise.resolve({
                isSuccess: true,
                data: payload
            });
        })
        .catch(ex => {
            this.removeCancelToken(id);
            if (axios.isCancel(ex)) {
                return Promise.reject({ isCancel: true });
            }
            console.log(ex);
            return Promise.reject(ex);
        });
    }

    private removeCancelToken(id) {
        const index = this.cancels.findIndex(x => x.id === id);
        if (index > -1) {
            this.cancels.splice(index, 1);
        }
    }
}
